import { defineStore } from 'pinia';
import axios from '@/api';

let fetchInProgress = false;

export const useAuthStore = defineStore('auth', {
    state: () => {
        // Try to load initial state from localStorage
        const savedState = localStorage.getItem('auth_store');
        const initialState = savedState ? JSON.parse(savedState) : {
            user: null,
            loading: false,
            initialized: false,
        };
        
        return initialState;
    },

    actions: {
        async loginUser(payload) {
            this.loading = true;
            console.log('[AuthStore] User login attempt with payload:', payload);
            try {
                await axios.post('/auth/login-user', payload);
                await this.fetchUser();
                return true;
            } catch (err) {
                console.error('[AuthStore] Login failed:', err);
                return false;
            } finally {
                this.loading = false;
            }
        },


        async loginKiosk(payload) {
            this.loading = true;
            // console.log('[AuthStore] Kiosk login attempt with payload:', payload);

            try {
                await axios.post('/auth/login-kiosk', payload);
                await this.fetchUser();
                return true;
            } catch (err) {
                console.error('[AuthStore] Login failed:', err);
                return false;
            } finally {
                this.loading = false;
            } 
        },

        async logoutUser() {
            try {
                await axios.post('/auth/logout-user');
            } catch (err) {
                console.error('[AuthStore] Logout failed:', err);
            } finally {
                this.user = null;
            }
        },


        async logoutKiosk(instanceId) {

            try {
                await axios.post('/auth/logout-kiosk', { kioskInstanceId: instanceId });
            } catch (err) {
                console.error('[AuthStore] Logout failed:', err);
            } finally {
                this.user = null;
            }
        },


        async fetchUser() {
            this.loading = true;
            try {
                // console.log('[AuthStore] Fetching user');
                const response = await axios.get('/auth/me');
                this.user = response.data;
                // console.log('[AuthStore] Fetch OK');
                return true;
            } catch (err) {
                console.log('[AuthStore] Fetch user failed:', err);
                this.user = null;
                return false;
            } finally {
                this.loading = false;
            }
        },
        
    },
});